import { TheNightlySection } from '@news-mono/common'
import { StaticRoutes } from '@news-mono/web-common'
import { createAllEditionsPage } from './createTravelEditionsPage'

export const travelEdition: StaticRoutes<TheNightlySection> = {
    '/lifestyle/travel/editions': (services) => {
        return createAllEditionsPage(services, 'default', 'The Nightly Travel')
    },
}
